import { handleActions } from 'redux-actions';

export default handleActions(
	{
		GET_PRODUCT_LIST_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_RECOMMEND_COURSE_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_PRODUCT_INFO_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		ADD_PRODUCT_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_PRODUCT_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		TRANSFER_PRODUCT_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_ACTIVITY_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		DEFAULT_PRODUCT_INFO: (state, action) => ({
			...state,
			...action.payload,
		}),

		MODE_TOGGLE: (state, action) => ({
			...state,
			modeList: action.payload.toggle,
		}),
	},
	{
		list: [],
		courseList: [],
		info: {
			type: '',
			name: '',
			image: '',
			oldBuyDate: '',
			purchase: '',
			shipping: '',
			warrantyMonth: '',
			warrantyEnd: '',
			dealer: '',
			dealerSell: '',
			archive: '',
			date: '',
			gift: false,
			invoice: '',
		},
		product: {
			id: '',
			type: '',
			number: '',
			name: '',
			code: '',
			image: '',
			date: '',
			warranty: '',
			warrantyEnd: '',
			gift: false,
		},
		maintain: [],
		transferName: '',
		giftEvent: '',
		transfered: {
			name: '',
			number: '',
		},
		addProduct: {
			event: false,
			id: '',
		},
		modeList: false,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/product.js